"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackingManager = void 0;

var _react = _interopRequireWildcard(require("react"));

var _matomoTrackerReact = require("@datapunt/matomo-tracker-react");

var _reactRedux = require("react-redux");

var _ = require("../../");

var _reactRouter = require("react-router");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * this component will manager all the matomo tracking
 * it must be used for tracking to work
 * it should be placed in root app router
 * example <Route path="/" component={TrackingManager} />
 */
var TrackingManager = function TrackingManager(props) {
  var _useMatomo = (0, _matomoTrackerReact.useMatomo)(),
      trackPageView = _useMatomo.trackPageView,
      trackEvent = _useMatomo.trackEvent,
      pushInstruction = _useMatomo.pushInstruction;

  var history = (0, _reactRouter.useHistory)();
  var user = (0, _reactRedux.useSelector)(function (state) {
    return state.user ? state.user.value : null;
  });
  var role = (0, _reactRedux.useSelector)(function (state) {
    // This should be a bit smarter for traceid and other apps
    var role = "anonymous";
    var user = state.user ? state.user.value : null;
    var team = state.team ? state.team.value : null; // check for user

    if (user) {
      // can be overridden by items below
      role = "user";
    } // check for parent


    if (user && team && team.members) {
      var rels = user.relations ? user.relations : [];

      var _iterator = _createForOfIteratorHelper(rels),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rel = _step.value;

          var _iterator2 = _createForOfIteratorHelper(team.members),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var member = _step2.value;

              if (member.user_id === rel.related_user.user_id) {
                role = "parent";
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          if (role === "parent") {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } // check for coach, manager, player


    if (user && team && team.members) {
      var _iterator3 = _createForOfIteratorHelper(team.members),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _member = _step3.value;

          if (_member.user_id == user.user_id) {
            if (_member.is_coach == "1") {
              role = "coach";
            } else if (_member.is_videographer == "1") {
              role = "manager";
            } else if (_member.is_player == "1") {
              role = "player";
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    return role;
  });

  var tmTrackEvent = function tmTrackEvent(ev) {
    var cat = (0, _.getProperty)("detail.category", ev, null);
    var act = (0, _.getProperty)("detail.action", ev, null);
    var lbl = (0, _.getProperty)("detail.label", ev, null);

    if (!cat || !act) {
      console.warn("TrackingManager.tmTrackEvent category and action are required", cat, act, lbl, ev.detail);
      return;
    }

    trackEvent({
      category: cat,
      action: act,
      name: lbl,
      customeDimensions: [{
        id: 1,
        value: role
      }]
    });
  };

  var tmTrackPageView = function tmTrackPageView(ev) {
    var href = ev.detail.replace("#/", "");
    var title = window.tm_title ? window.tm_title : document.title; //console.log("TrackingManager tmTrackPageView", href)

    trackPageView({
      href: href,
      documentTitle: title
    });
  };

  var tmTrackContent = function tmTrackContent(ev) {
    var name = ev.detail.name;
    var piece = ev.detail.content;
    var url = ev.detail.url; //console.log("TrackingManager.tmTrackContent", name, piece, url)

    pushInstruction("trackContentImpression", name, piece, url);
  };

  if (window.tm_content !== "YES") {
    window.tm_content = "YES";
    pushInstruction("trackAllContentImpressions");
  }

  if (user && user.user_id) {
    if (window.tm_user_id !== user.user_id) {
      window.tm_user_id = user.user_id; //console.log("TrackingManager.user", user)

      pushInstruction("setUserId", user.user_id);
    }
  }

  if (window.tm_role != role) {
    window.tm_role = role; //console.log("role", role)

    pushInstruction("setCustomDimension", 1, role);
  }

  (0, _react.useEffect)(function () {
    //console.log("TrackingManager setup listeners")
    document.addEventListener("trc-track-event", tmTrackEvent);
    document.addEventListener("trc-track-page", tmTrackPageView);
    document.addEventListener("trc-track-content", tmTrackContent);
    return function () {
      //console.log("TrackingManager remove listeners")
      document.removeEventListener("trc-track-event", tmTrackEvent);
      document.removeEventListener("trc-track-page", tmTrackPageView);
      document.removeEventListener("trc-track-content", tmTrackContent);
    };
  });
  (0, _react.useEffect)(function () {
    tmTrackPageView({
      detail: window.location.href
    });
  }, [history.location]);
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "none"
    }
  });
};

exports.TrackingManager = TrackingManager;